import {
    SET_ENABLED_FEATURES,
    EnabledFeature,
} from './types';

export interface SetEnabledFeatures {
    type: typeof SET_ENABLED_FEATURES;
    enabledFeatures: EnabledFeature[];
}

export const setEnabledFeaturesAction = (
    enabledFeatures: EnabledFeature[],
): SetEnabledFeatures => ({
    type: SET_ENABLED_FEATURES,
    enabledFeatures: enabledFeatures,
});